export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-global-line',
      title: 'Red Internacional Consolidada',
      description: 'Más de 10 años estableciendo relaciones sólidas con los mejores fabricantes chinos del sector construcción y decoración.'
    },
    {
      icon: 'ri-time-line',
      title: 'Plazos de Entrega Garantizados',
      description: 'Cumplimiento del 98% en fechas acordadas. Tu proyecto no esperará gracias a nuestra logística optimizada y stock estratégico.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipo Bilingüe Especializado',
      description: 'Personal con dominio de español, chino e inglés. Facilitamos la comunicación y eliminamos barreras culturales en cada transacción.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Certificaciones Internacionales',
      description: 'Todos nuestros productos cumplen normativas CE, ISO y certificaciones específicas del sector construcción europeo.'
    }
  ];

  return (
    <section className="py-24 bg-blue-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-800 text-blue-100 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Por Qué Elegirnos
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Tu Socio de Confianza en Importación
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Combinamos experiencia internacional, tecnología avanzada y un compromiso inquebrantable con la excelencia para hacer crecer tu negocio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-blue-800 rounded-full mx-auto mb-6 border-4 border-blue-700">
                <i className={`${feature.icon} text-4xl text-blue-100`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-blue-100 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-blue-800 rounded-2xl p-8 md:p-12 border border-blue-700">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Proceso Transparente y Eficiente</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-700 rounded-full mr-4 flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Consulta Inicial</h4>
                    <p className="text-blue-100 text-sm">Analizamos tus necesidades específicas y te asesoramos sobre las mejores opciones disponibles en el mercado chino.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-700 rounded-full mr-4 flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Selección y Muestras</h4>
                    <p className="text-blue-100 text-sm">Te proporcionamos muestras físicas y especificaciones técnicas detalladas para tu evaluación profesional.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-700 rounded-full mr-4 flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Pedido y Control</h4>
                    <p className="text-blue-100 text-sm">Gestionamos la producción con inspecciones en origen y te mantenemos informado en cada etapa del proceso.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-700 rounded-full mr-4 flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">4</span>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Entrega y Soporte</h4>
                    <p className="text-blue-100 text-sm">Recepción en tu ubicación con toda la documentación legal y soporte post-venta continuado.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20international%20partners%20in%20modern%20office%20with%20world%20map%20background%2C%20symbolizing%20global%20trade%20partnership%20and%20trust%20in%20construction%20materials%20import%20business%2C%20clean%20corporate%20environment%20with%20blue%20tones%20and%20professional%20atmosphere&width=600&height=700&seq=why-choose-zhongming-002&orientation=portrait"
                alt="Proceso profesional"
                className="rounded-xl shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
